module.exports = "/_next/static/images/icon-logo-e84fda2e.png";